import React from 'react'
import Col from '../../UIcomponent/Column'
import StyledButton from '../../UIcomponent/Button'
import './CardTitleAction.scss';
import StyledLink from '../../UIcomponent/Link';
export const CardTitleAction = (props) => {
    const { url, role } = props
    return (
        <>
            <Col
                className='l__CardTitleAction'
                xl={24} lg={24} md={24} sm={24} xs={24}
            >
                <Col
                    className='c__CardTitleAction__Title'
                    xl={12} lg={12} md={12} sm={8} xs={8}
                >
                    {props.title}
                </Col>
                <Col
                    className='c__CardTitleAction__Action'
                    xl={12} lg={12} md={12} sm={16} xs={16}
                >
                    {/* {!props.noAction && */}
                    {!props.noAction &&
                        <>

                            <StyledButton
                                secondary
                                disable={!props.hasEditAction}
                                className='o__CardTitleAction__Action--ٍEdit'
                                height={'40px'}
                                onClick={props.editAction}
                            >
                                {props.editActionTitle || 'ویرایش'}
                            </StyledButton>
                            {/* } */}
                            {props.hasWatchAction && role === 'Teacher' &&
                                <StyledButton
                                    primary
                                    className='o__CardTitleAction__Action--Watch'
                                    height={'40px'}
                                >
                                    <StyledLink
                                        to={url}
                                    >
                                        {props.WatchActionTitle}
                                    </StyledLink>
                                </StyledButton>
                            }
                        </>
                    }
                </Col>
                {!props.noBorder &&
                    <Col
                        xl={24} lg={24} md={24} sm={24} xs={24}
                        className='H__Divider'
                    >
                    </Col>
                }
            </Col >

        </>
    )
}
